<div class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">

    <!-- Header (Standard Project Style) -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
                จัดการกลุ่มจุดให้บริการ
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการกลุ่มทางเข้า-ออก
                และตรวจสอบข้อมูลแยกตามโครงการ</p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="openCreateModal()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2 h-[46px]">
                <span class="material-icons text-xl">add_circle</span>
                สร้างกลุ่มใหม่
            </button>
        </div>
    </div>

    <!-- Dashboard stats (Standard Project Style) -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 mt-2">
        <div *ngFor="let stat of stats; let i = index"
            class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 group relative overflow-hidden"
            [style.animation-delay]="(i * 100) + 'ms'">

            <!-- Background Icon Decoration -->
            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm transition-transform group-hover:scale-110 duration-500"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl">{{ stat.icon }}</span>
                </div>
                <div class="opacity-0 group-hover:opacity-100 transition-opacity">
                    <span class="material-icons text-amber-500/30 text-xl font-bold">trending_up</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                </h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value |
                    number }}</div>
            </div>
        </div>
    </div>

    <!-- Main Table Container (Standard Project Style) -->
    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay: 0.2s;">

        <!-- Table Header Control Bar -->
        <div
            class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">list_alt</span>
                รายการกลุ่มจุดให้บริการ
            </h3>

            <div class="flex flex-col xl:flex-row gap-3 w-full xl:w-auto">
                <!-- Site Filter Dropdown -->
                <div class="relative min-w-[200px]">
                    <button (click)="toggleFilterDropdown()"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100/50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">place</span>
                            {{ filterSite || 'ทั้งหมด (โครงการ)' }}
                        </span>
                        <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isFilterDropdownOpen}">expand_more</span>
                    </button>

                    <!-- Overlay backdrop -->
                    <button *ngIf="isFilterDropdownOpen" class="fixed inset-0 cursor-default z-30"
                        (click)="toggleFilterDropdown()"></button>

                    <!-- Dropdown List -->
                    <div *ngIf="isFilterDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-[250px] bg-white dark:bg-slate-800 rounded-2xl shadow-xl border border-slate-100 dark:border-slate-700 py-3 z-40 animate-fade-in-up">
                        <div
                            class="px-4 pb-2 mb-2 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-50 dark:border-slate-700/50">
                            เลือกโครงการ</div>
                        <div (click)="selectSiteFilter('')"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>ทุกโครงการ</span>
                            <span *ngIf="!filterSite" class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                        <div *ngFor="let site of siteOptions" (click)="selectSiteFilter(site)"
                            class="px-4 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 cursor-pointer transition-all flex items-center justify-between">
                            <span>{{ site }}</span>
                            <span *ngIf="filterSite === site"
                                class="material-icons text-amber-500 text-lg">check_circle</span>
                        </div>
                    </div>
                </div>

                <!-- Search Input -->
                <div class="relative flex-1 flex w-full xl:min-w-[400px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100/50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-hidden h-[46px]">
                        <span
                            class="absolute left-4 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                        <input type="text" placeholder="หาตามชื่อกลุ่ม, โครงการ, หรือทางเข้า..."
                            [(ngModel)]="searchText" (input)="applyFilters()"
                            class="w-full pl-12 pr-4 py-2 bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500">
                        <button (click)="applyFilters()"
                            class="h-full px-6 text-sm font-black text-white bg-amber-400 hover:bg-amber-500 transition-colors uppercase tracking-widest">
                            ค้นหา
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table View -->
        <div class="overflow-x-auto min-h-[500px] relative custom-scrollbar">
            <app-pss-loading *ngIf="isLoading"></app-pss-loading>

            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm border-b border-slate-100 dark:border-slate-700">
                    <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">
                        <th (click)="sortData('id')"
                            class="p-6 pl-10 whitespace-nowrap cursor-pointer hover:text-slate-700 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1.5 focus:text-amber-500">
                                ID
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'id'">
                                    {{ sortColumn === 'id' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('name')"
                            class="p-6 whitespace-nowrap cursor-pointer hover:text-slate-700 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1.5">
                                กลุ่มจุดให้บริการ
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'name'">
                                    {{ sortColumn === 'name' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-6">จุดให้บริการ (Service Points)</th>
                        <th (click)="sortData('site')"
                            class="p-6 whitespace-nowrap cursor-pointer hover:text-slate-700 dark:hover:text-slate-300 transition-colors group">
                            <div class="flex items-center gap-1.5">
                                โครงการ
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'site'">
                                    {{ sortColumn === 'site' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-6 text-center pr-10">จัดการ</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let g of paginatedGroups; let i = index"
                        class="group hover:bg-amber-50/30 dark:hover:bg-slate-700/40 transition-all duration-200 cursor-pointer animate-table-row"
                        [style.animation-delay]="(i * 0.03) + 's'">
                        <td class="p-6 pl-10 font-mono text-sm font-bold text-slate-400">{{ g.id }}</td>
                        <td class="p-6 whitespace-nowrap">
                            <div class="flex items-center gap-3">
                                <div
                                    class="shrink-0 w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-slate-500 dark:text-slate-400 font-black text-[10px] shadow-sm group-hover:bg-white dark:group-hover:bg-slate-800 group-hover:text-amber-500 transition-all">
                                    {{ g.name ? g.name.charAt(0) : 'G' }}
                                </div>
                                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ g.name }}</span>
                            </div>
                        </td>
                        <td class="p-6">
                            <div class="flex flex-wrap gap-2">
                                <span *ngFor="let p of g.servicePoints"
                                    class="px-3 py-1 bg-white dark:bg-slate-800 border-2 border-slate-50 dark:border-slate-700 rounded-full text-[10px] font-black text-slate-500 shadow-sm transition-all group-hover:border-amber-100">
                                    {{ p }}
                                </span>
                            </div>
                        </td>
                        <td class="p-6">
                            <span
                                class="inline-flex items-center gap-2 px-4 py-1.5 bg-amber-50 dark:bg-amber-900/10 text-amber-600 dark:text-amber-400 text-xs font-black rounded-xl border border-amber-100/50 uppercase tracking-widest shadow-sm">
                                <span class="material-icons text-[14px]">place</span>
                                {{ g.site }}
                            </span>
                        </td>
                        <td class="p-6 text-center pr-10">
                            <button (click)="openEditModal(g); $event.stopPropagation()"
                                class="inline-flex items-center justify-center w-9 h-9 rounded-xl text-blue-500 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 hover:text-white transition-all shadow-sm hover:scale-110 active:scale-95 group-hover:shadow-blue-200 opacity-0 group-hover:opacity-100">
                                <span class="material-icons text-[18px]">edit</span>
                            </button>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="filteredGroups.length === 0 && !isLoading">
                        <td colspan="5" class="py-24 text-center">
                            <div class="flex flex-col items-center justify-center grayscale opacity-30">
                                <span class="material-icons text-6xl">search_off</span>
                                <h3 class="text-lg font-black uppercase tracking-widest mt-4">ไม่พบข้อมูล</h3>
                                <p class="text-sm font-bold mt-1">ลองเปลี่ยนคำค้นหาหรือตัวกรองโครงการ</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination Footer (Standard Project Style) -->
        <div
            class="px-8 py-5 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-6 w-full rounded-b-3xl">
            <div class="flex items-center gap-5 text-sm text-slate-500 dark:text-slate-400 font-bold">
                <span>แสดง {{ ((currentPage-1)*pageSize) + 1 }} - {{ currentPage * pageSize > totalItems ? totalItems :
                    currentPage * pageSize }} จาก {{ totalItems | number }} รายการ</span>
                <div class="flex items-center gap-2">
                    <span class="text-[10px] font-black uppercase tracking-widest">ต่อหน้า:</span>
                    <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                        class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-xs rounded-xl block p-2 pr-8 font-black outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 shadow-sm transition-all">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} รายการ</option>
                    </select>
                </div>
            </div>

            <div class="flex items-center gap-2">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>

                <div class="flex items-center gap-1.5">
                    <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                        class="w-10 h-10 flex items-center justify-center rounded-xl text-xs font-black transition-all"
                        [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200' : 'text-slate-600 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600'">
                        {{ page }}
                    </button>
                </div>

                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
                    class="w-10 h-10 flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-provider-group-spot *ngIf="isModalOpen" [data]="selectedGroup" (close)="closeModal()"
        (saveSuccess)="onRefresh()">
    </app-modal-provider-group-spot>

</div>